The result for the `verifyCandidate` mutation when the candidate is already verified.
